"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _CostItemTableTree = _interopRequireDefault(require("../CostItemTableTree"));
var _SubjectEditCustom = _interopRequireDefault(require("./SubjectEditCustom"));
var _SubjectEditCommonTemplate = _interopRequireDefault(require("./SubjectEditCommonTemplate"));
var _useReportSubjectEditor = require("./useReportSubjectEditor");
var _default = exports.default = {
  name: 'ReportSubjectEditModal',
  // 智能报表-添加科目-添加或编辑弹框
  inject: ['dimension', 'bizType', 'source', 'type'],
  data() {
    return {
      visible: false,
      operate: 'add',
      // add-添加一级科目 add-child-添加子科目 edit-编辑
      curRecord: undefined,
      // 当前编辑的节点
      // activeKey为CostItem时该值为数组，已选中的科目列表 [{type(Default原子科目/CustomFormula复合科目/Stat统计科目),_title,_rawValue}]
      // activeKey为Common时该值为数组，已选中的科目列表 [与DEFAULT_TPL_CONFIG字段一致]
      editResult: undefined,
      // 当前编辑的结果
      index: 0,
      // 插入数据的索引
      activeKey: 'Common'
    };
  },
  computed: {
    validTabs() {
      const tabs = [
      // 仅在“智能报表-个人模板”路径下新建科目时显示“从公共模板添加”
      {
        name: '从公共模板添加',
        type: 'Common',
        component: _SubjectEditCommonTemplate.default,
        valid: this.operate !== 'edit' && this.bizType === 'Report' && this.source === 'Personal'
      }, {
        name: '从科目库添加',
        type: 'CostItem',
        component: _CostItemTableTree.default,
        valid: this.operate !== 'edit'
      }, {
        name: '自定义添加',
        type: 'Custom',
        component: _SubjectEditCustom.default,
        valid: true
      }];
      return tabs.filter(tab => tab.valid);
    }
  },
  methods: {
    open({
      operate,
      record,
      index
    }) {
      this.operate = operate;
      this.curRecord = _.cloneDeep(record);
      this.index = index;
      this.activeKey = this.validTabs[0].type;
      this.visible = true;
    },
    close() {
      this.curRecord = undefined;
      this.editResult = undefined;
      this.visible = false;
    },
    handleChange(res) {
      const {
        activeKey
      } = this;
      if (['Common', 'Custom'].includes(activeKey)) {
        this.editResult = res;
      } else if (activeKey === 'CostItem') {
        this.editResult = res.selectedItemList;
      }
    },
    // 从科目库添加
    getCostItemResult() {
      return this.editResult.map((item, _index) => {
        const time = new Date().getTime();
        return Object.assign(_.cloneDeep(_useReportSubjectEditor.DEFAULT_TPL_CONFIG), {
          id: (time + _index).toString(),
          name: item._title,
          type: `costItem${item.type}`,
          statType: 'api',
          formulaCode: item._rawValue,
          formulaName: item._title
        });
      });
    },
    // 点击“确定”按钮
    async handleOk() {
      if (this.activeKey === 'CostItem' && this.editResult.length === 0) {
        _antDesignVue.message.warning('请选择需要添加的科目');
        return;
      }
      const {
        activeKey,
        operate,
        curRecord,
        editResult,
        index
      } = this;
      if (activeKey === 'Common') {
        // 从公共模板添加
        editResult.map((item, _index) => {
          this.$emit('ok', operate, item, index + _index);
        });
      } else if (activeKey === 'CostItem') {
        // 从科目库添加
        editResult.map((item, _index) => {
          const time = new Date().getTime();
          const _record = Object.assign(_.cloneDeep(_useReportSubjectEditor.DEFAULT_TPL_CONFIG), {
            pid: operate === 'add-child' ? curRecord.id : _useReportSubjectEditor.ROOT_ID,
            id: (time + _index).toString(),
            name: item._title,
            type: `costItem${item.type}`,
            statType: 'api',
            formulaCode: item._rawValue,
            formulaName: item._title
          });
          // index + _index ==》 确保科目按顺序插入
          this.$emit('ok', operate, _record, index + _index);
        });
      } else if (activeKey === 'Custom') {
        // 自定义添加
        const valid = await this.$refs.componentRef[0].validate();
        if (valid) this.$emit('ok', operate, editResult, index);
      }
    }
  }
};